(function ($, window, document, undefined) {
	var defaultOptions = {
		mat: -1,
		oldMat: -1,
		matches: 0,
		wrestlers: 0,
	}

	$.fn.updateMatTable = function (customOptions) {

		var options = $.extend({}, defaultOptions, customOptions);

		var mat = options.mat,
			oldMat = options.oldMat,
			matches = options.matches,
			wrestlers = options.wrestlers;

		var totalsTable = $('#totalsTable'),
			thisMatsRow = totalsTable.find('.mat-' + mat),
			oldMatsRow = totalsTable.find('.mat-' + oldMat);

		if (thisMatsRow.length) {
			var currentWrestlers = thisMatsRow.find('.wrestlerCount'),
				currentMatches = thisMatsRow.find('.matches');

			currentWrestlers.text(wrestlers + parseInt(currentWrestlers.text()));
			currentMatches.text(matches + parseInt(currentMatches.text()));
		} else {
            if(mat !== -1) {
				totalsTable.append(
					'<tr class="totalsRow mat-' + mat + '"> ' +
					'<td class="text-center matNumber">' +
					mat +
					'</td>' +
					'<td class="text-center matches">' +
					matches +
					'</td>' +
					'<td class="text-center wrestlerCount">' +
					wrestlers +
					'</td>' +
					'</tr>'
				);
			}
		}

		if (oldMatsRow.length) {
			var oldWrestlers = oldMatsRow.find('.wrestlerCount'),
				oldMatches = oldMatsRow.find('.matches');

			oldWrestlers.text(parseInt(oldWrestlers.text()) - wrestlers);
			oldMatches.text(parseInt(oldMatches.text()) - matches);
		}
	};



})(jQuery, this, this.document);
